/* Ayudate · Orden del listado */

/* ------------------------------------------------------------------
   Puntaje de posicionamiento (media bayesiana)

   Una nota alta con pocas reseñas no es confiable: tres personas contentas
   no dicen lo mismo que cuarenta. La fórmula mezcla la nota del tutor con
   el promedio general y le da más peso a la propia conforme acumula reseñas.

       puntaje = (v / (v + M)) x nota  +  (M / (v + M)) x promedioGeneral

   v = reseñas del tutor · M = reseñas necesarias para "pesar" solo.

   Con M = 10 y promedio general 4,76:
     4,9 con 34 reseñas -> 4,867   (queda arriba)
     5,0 con  3 reseñas -> 4,812
------------------------------------------------------------------- */
export const M_RESENAS = 10;

export const promedioGeneral = (lista) => {
  const con = lista.filter((t) => t.rating !== null && t.resenas > 0);
  if (!con.length) return 4.5;
  const total = con.reduce((s, t) => s + t.rating * t.resenas, 0);
  const votos = con.reduce((s, t) => s + t.resenas, 0);
  return total / votos;
};

export const puntaje = (t, C) => {
  if (t.rating === null || !t.resenas) return C - 0.35;   // sin reseñas: apenas por debajo
  const v = t.resenas;
  return (v / (v + M_RESENAS)) * t.rating + (M_RESENAS / (v + M_RESENAS)) * C;
};

/* ------------------------------------------------------------------
   Desempate por antigüedad

   Dos tarjetas con las mismas sesiones y el mismo puntaje quedaban en el
   orden en que venían del servidor, y ese orden es el de la hoja: como cada
   registro se inserta ARRIBA (insertarAlInicio en apps-script.gs), la
   tarjeta creada ayer le pasaba por encima a la que llevaba meses empatada
   con ella, y el empate se resolvía al revés de lo que corresponde. Entre
   iguales manda la antigüedad: primero la que se publicó antes.

   La fecha es la de la FILA, o sea la del curso: cada oferta es su propia
   fila con su propio `creado` (ver expandirOfertas en lib/horarios.js). La
   tarjeta a la que no le llegue fecha se va al FINAL del empate, no al
   frente: sin dato no hay antigüedad que reclamar.
------------------------------------------------------------------- */
export const fechaCreacion = (t) => {
  const ms = new Date(t?.creado ?? NaN).getTime();
  return Number.isNaN(ms) ? Infinity : ms;
};

export const masAntiguoPrimero = (a, b) => {
  const fa = fechaCreacion(a), fb = fechaCreacion(b);
  return fa === fb ? 0 : fa - fb;   // restar dos Infinity daría NaN
};
